export function setSessionStatus(status) {
	return (dispatch) => {
		dispatch({
			type: "setSessionStatus",
			payload: status
		});
	};
}

export function saveQuote(quote) {
	const err = new Error();
	return (dispatch) => {
		dispatch({
			type: "saveQuote",
			payload: quote
		});
	};
}

export function clearQuotes() {
	return (dispatch) => {
		dispatch({
			type: "clearQuotes"
		});
	};
}
